import { css } from '@emotion/react';
import {
  hiddenOnMobile,
  mediaQueries,
  urls,
  visibleOnlyOnMobile,
} from '@zapier/identity-utils';
import { atoms, Button, colors } from '@zapier/marketing-ui';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';

const styles = {
  root: css({
    padding: 24,
    display: 'grid',
    gap: 16,
    justifyItems: 'start',
    backgroundColor: colors.neutral200,
    color: colors.neutral900,
    borderRadius: 4,

    [mediaQueries.tablet]: {
      padding: 32,
      gap: 24,
    },
  }),

  img: css({
    display: 'block',
    width: 128,
    height: 96,
    maxWidth: '100%',
    objectFit: 'contain',
  }),
};

export function CompaniesIntroPromo() {
  const t = useTranslations('companies-intro-promo');

  const isReviewMode = useMemo(() => {
    if (typeof window === 'undefined') return false;
    const params = new URLSearchParams(window.location.search);
    return params.get('review') === 'true';
  }, []);

  if (isReviewMode) {
    return (
      <div css={styles.root}>
        <h3 className={atoms.headingXS}>{t('review.heading')}</h3>
        <p className={atoms.body}>{t('review.description')}</p>
      </div>
    );
  }

  return (
    <div css={styles.root}>
      <img
        css={styles.img}
        src="https://res.cloudinary.com/zapier-media/image/upload/q_auto/f_auto/v1769615779/enterprise_illustration_izoxxo.png"
        width="128"
        height="96"
        alt=""
      />
      <h2 className={atoms.headingXS}>{t('heading')}</h2>
      <p className={atoms.body}>{t('description')}</p>
      <Button
        href={urls.ENTERPRISE_PLAN_URL}
        variant="secondary"
        size="small"
        clickEventDetails={{
          interaction_name: 'cta_link_clicked',
        }}
      >
        <span css={hiddenOnMobile}>{t('explore-enterprise')}</span>
        <span css={visibleOnlyOnMobile}>{t('learn-more')}</span>
      </Button>
    </div>
  );
}
